export class Numbers {
  /**
   * @param value - to check if an integer
   * @returns true if value is an integer
   */
  static isInteger(value: number): boolean {
    return Number.isInteger(value);
  }

  /**
   * @param value - The value to round
   * @returns the rounded value ending on 8 / or if value is illegal NaN
   */
  // this is not working with "1769" !!!!!!!!!!
  static toNearest8(value: number): number {
    if (isNaN(value) || value === null) return NaN;
    if (value >= 0) return Math.floor(value / 10) * 10 + 8;
    else return Math.ceil(value / 10) * 10 - 8;
  }

  /**
   * Floors a given value to the nearest number ending with digit 8
   * @param value The value to be floored
   * @returns The number ending with 8
   */
  static floorToNearest8(value: number): number {
    if (isNaN(value) || value === null) return NaN;
    return Math.floor((value - 8) / 10) * 10 + 8;
  }

  /**
   * @param value - The value to round
   * @param digits - The number of digits to round to
   * @returns the rounded value / or if value is illegal NaN
   */
  static toDecimal(value: number, digits = 2): number {
    if (isNaN(value) || value === null) return NaN;
    return Math.round(value * Math.pow(10, digits)) / Math.pow(10, digits);
  }
}
